module.exports = __webpack_public_path__ + "assets/img/Spark-Systems-Website-w960.f1d759f7.webp";